export function getModalStyle(){
    return  {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'fit-content',
        // maxHeight: '80vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        
    };
}

export function PTRModalStyle() {
    return {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        height: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        bgcolor: 'background.paper',
        border: '3px solid #084d8b',
        borderRadius: 5,
        boxShadow: 24,
        maxHeight: '80vh',
        p: 4,
    }
}